import { NavigateFunction } from 'react-router-dom';
import ROUTES from '../../constants/routes';
import axios from '../axios';

type NavigateFreeThankYouPropsType = {
    materialId: number;
    navigate: NavigateFunction;
};

const navigateFreeThankYou = ({ materialId, navigate }: NavigateFreeThankYouPropsType) => {
    axios.get(`v1/order/free-material/request/${materialId}`, { params: { directLink: true } }).then((res) => {
        const token = res?.data?.items?.token;

        navigate(`${ROUTES.FREE_DOWNLOAD.path.replace(':token', token)}`, {
            state: { download: true }
        });
    });
};

export default navigateFreeThankYou;
